import { TokenStorage } from './token-storage';

export class TokenStorageFactory {
  private static instance: TokenStorage;
  static getTokenStorage(clientId: string, authority: string): Storage {
    if (!this.instance) {
      this.instance = new TokenStorage(clientId, authority);
    }
    return this.instance;
  }

  static getInstanz(): TokenStorage {
    return this.instance;
  }
}
